import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CYCLE_MS = 5000;

export default function UploadAnimation({ trigger }) {
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    if (!trigger) return;
    const id = setInterval(() => setCycle((c) => c + 1), CYCLE_MS);
    return () => clearInterval(id);
  }, [trigger]);

  return (
    <svg viewBox="0 0 200 140" fill="none" className="w-full h-full">
      {/* Phone silhouette */}
      <rect x="16" y="20" width="52" height="90" rx="8" fill="white" stroke="#D1D5DB" strokeWidth="1.5" />
      <rect x="32" y="24" width="20" height="3" rx="1.5" fill="#E5E7EB" />

      {/* Chat bubbles inside phone */}
      <rect x="22" y="36" width="30" height="6" rx="3" fill="#FFE0E3" />
      <rect x="30" y="48" width="28" height="6" rx="3" fill="#F3F4F6" />
      <rect x="22" y="60" width="24" height="6" rx="3" fill="#FFE0E3" />
      <rect x="28" y="72" width="32" height="6" rx="3" fill="#F3F4F6" />

      {/* Dashed upload box */}
      <rect
        x="120" y="28" width="64" height="72" rx="10"
        fill="none" stroke="#D1D5DB" strokeWidth="1.5" strokeDasharray="5 4"
      />
      {/* Cloud icon inside box */}
      <path
        d="M144 68c-4.4 0-8-3.6-8-8 0-3.7 2.5-6.8 6-7.7C142.5 48.5 146 46 150 46c5 0 9 3.6 9.7 8.3 2.8.7 4.3 3 4.3 5.7 0 3.3-2.7 6-6 6h-2"
        stroke="#D1D5DB" strokeWidth="1.2" fill="none" strokeLinecap="round"
      />
      <path
        d="M152 72v-8m-3 3l3-3 3 3"
        stroke="#D1D5DB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"
      />

      {/* Animated elements — remount each cycle for seamless loop */}
      {trigger && (
        <g key={cycle}>
          {/* File icon arcing from phone to upload box */}
          <motion.g
            initial={{ x: 0, y: 0, opacity: 0 }}
            animate={{
              x:       [0, 0, 15, 40, 60, 60, 60],
              y:       [0, 0, -20, -30, -10, -10, -10],
              scale:   [1, 1, 0.95, 0.9, 0.85, 0.85, 0.85],
              opacity: [0, 1, 1,    1,   1,    1,    0],
            }}
            transition={{
              duration: 3.8,
              times:    [0, 0.05, 0.25, 0.45, 0.6, 0.72, 0.85],
              ease: 'easeInOut',
            }}
          >
            <rect x="72" y="52" width="28" height="34" rx="3" fill="white" stroke="#FF6B81" strokeWidth="1.2" />
            <path d="M88 52v10h10" stroke="#FF6B81" strokeWidth="1" fill="#FFE0E3" />
            <rect x="77" y="68" width="16" height="2" rx="1" fill="#FFD5D9" />
            <rect x="77" y="73" width="12" height="2" rx="1" fill="#FFD5D9" />
            <rect x="77" y="78" width="14" height="2" rx="1" fill="#FFD5D9" />
          </motion.g>

          {/* Green check that pops in after file lands */}
          <motion.g
            initial={{ scale: 0, opacity: 0 }}
            animate={{
              scale:   [0, 0, 1.2, 1, 1, 0],
              opacity: [0, 0, 1,   1, 1, 0],
            }}
            transition={{
              duration: 3.8,
              times:    [0, 0.5, 0.6, 0.67, 0.85, 0.97],
              ease: 'easeOut',
            }}
            style={{ transformOrigin: '152px 64px' }}
          >
            <circle cx="152" cy="64" r="12" fill="#2FAF7F" />
            <path d="M146 64l4 4 8-8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </motion.g>
        </g>
      )}
    </svg>
  );
}
